/**
 * Chef Banchan Event System - ES5 Compatible
 * 이벤트 제품 감지 및 캘린더 필터링 시스템
 */



window.ChefBanchanEvents = {
  kimchiPresale2026: {
  enabled: true,
  name: '김치 사전예약',
  skus: ['0DG-0IB-00', '0DH-0IC-00', '0HF-0M8-00'],
  dateRange: {
    start: '2026-03-26',
    end: '2027-12-31'  // 사실상 무기한
  },
  subtitle: {
    delivery: 'Pre-order kimchi ships starting March 26.',
    pickup: 'Pre-order kimchi available for pickup starting March 26.'
  },
  badge: 'Pre-order',
  color: '#FF4713',
  priority: 1
},

  newyear2026: {
    enabled: false, 
    name: '설날세트',
    skus: ['0FX-0KQ-00', '0FW-0KP-00'], 
    dateRange: {
      start: '2026-02-12',
      end: '2026-02-18'
    },
    specialDeliveryRules: {
      LA_OC: {
        deliveryDays: {
          4: 'Direct delivery',
          5: 'Direct delivery',
          6: 'FedEx',
          1: 'Direct delivery',
          2: 'Direct delivery',
          3: 'Direct delivery',
        }
      },
      SOCAL: {
        deliveryDays: {
          5: 'FedEx',
          6: 'FedEx',
          2: 'FedEx',
          3: 'FedEx',
        }
      },
      NATIONWIDE: {
        deliveryDays: {
          5: 'FedEx',
          2: 'FedEx',
          3: 'FedEx',
        }
      }
    },
    orderCutoff: {
      'NATIONWIDE': '2026-02-16T23:59:59',
      'SOCAL': '2026-02-17T23:59:59',
      'LA_OC': '2026-02-18T23:59:59'
    },
    subtitle: {
      delivery: '설날세트 배송 기간: 2월 12일 - 18일',
      pickup: '설날세트 픽업 기간: 2월 12일 - 18일'
    },
    badge: ' ',
    color: '#DC143C',
    priority: 1
  }
};

// Event System IIFE
(function() {
  console.log('🎯 Event System Start');
  
  function getActiveEvents() {
    var events = window.ChefBanchanEvents || {};
    var activeEvents = [];
    
    for (var key in events) {
      if (events.hasOwnProperty(key) && events[key].enabled) {
        var event = events[key];
        event.id = key;
        activeEvents.push(event);
      }
    }
    
    return activeEvents;
  }
  
  function detectEventProducts() {
    return fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var activeEvents = getActiveEvents();
        var detectedEvents = [];
        
        for (var i = 0; i < activeEvents.length; i++) {
          var event = activeEvents[i];
          var eventItems = [];
          
          for (var j = 0; j < cart.items.length; j++) {
            var item = cart.items[j];
            if (event.skus.indexOf(item.sku || '') !== -1) {
              eventItems.push(item);
            }
          }
          
          if (eventItems.length > 0) {
            event.items = eventItems;
            detectedEvents.push(event);
            console.log('✅ ' + event.name + ' Detected');
          }
        }
        
        detectedEvents.sort(function(a, b) {
          return (a.priority || 999) - (b.priority || 999);
        });
        
        return detectedEvents;
      })
      .catch(function(error) {
        console.error('❌ Cart Check Failed:', error);
        return [];
      });
  }


  function updateSubtitle(events) {
    console.log('🔍 updateSubtitle 호출됨 - events:', events.length, '시간:', new Date().toLocaleTimeString());
    var subtitle = document.getElementById('calendar-subtitle');
    if (!subtitle) return;
  
  var today = new Date();
  var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var dayNames = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
  var todayMonth = monthNames[today.getMonth()];
  var todayDate = today.getDate();
  var todayDay = dayNames[today.getDay()];
  var todayText = '[Today: ' + todayMonth + ' ' + todayDate + ' ' + todayDay + ']';
  
  if (events.length === 0) {
    var fulfillmentMethodInput = document.getElementById('selectedFulfillmentMethod');
    var isPickupMode = fulfillmentMethodInput && fulfillmentMethodInput.value === 'pickup';
    var defaultMsg = isPickupMode ? 'Please select your pickup date.' : 'Please select your delivery date.';
    subtitle.innerHTML = todayText + ' - ' + defaultMsg;
    subtitle.style.color = '#808080';
    return;
  }
  
  var event = events[0];
  
  // 🔥 배송/픽업 모드 확인
  var fulfillmentMethodInput = document.getElementById('selectedFulfillmentMethod');
  var isPickupMode = fulfillmentMethodInput && fulfillmentMethodInput.value === 'pickup';
  
  // 🔥 메시지 선택
  var message = isPickupMode ? event.subtitle.pickup : event.subtitle.delivery;
  
  subtitle.innerHTML = todayText + ' ' + message;
  subtitle.style.color = event.color;
  
  console.log('✅ Subtitle Updated: ' + event.name);
}


  
  function filterEventDates(events) {
    if (events.length === 0) {
      restoreAllDates();
      return;
    }
    
    var event = events[0];
    var startDate = new Date(event.dateRange.start);
    var endDate = new Date(event.dateRange.end);
    var dateOptions = document.querySelectorAll('.date-option');
    var validCount = 0;
    var hiddenCount = 0;
    
    var zipcodeEl = document.getElementById('current-zipcode');
    var zipcode = zipcodeEl ? zipcodeEl.textContent : '92831';
    var zone = 'LA_OC';
    
    if (window.ChefBanchan && window.ChefBanchan.ZipCodeManager) {
      zone = window.ChefBanchan.ZipCodeManager.getDeliveryZone(zipcode);
    }
    
    var fulfillmentMethodInput = document.getElementById('selectedFulfillmentMethod');
    var isPickupMode = fulfillmentMethodInput && fulfillmentMethodInput.value === 'pickup';
    
    console.log('🎯 이벤트 필터링:', event.name, '/', isPickupMode ? '픽업 모드' : '배송 모드');
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      var dateStr = option.dataset.date;
      if (!dateStr) continue;
      
      var optionDate = new Date(dateStr);
      var isInRange = optionDate >= startDate && optionDate <= endDate;
      
      if (event.specialDeliveryRules && !isPickupMode) {
        var dayOfWeek = optionDate.getDay();
        var zoneRules = event.specialDeliveryRules[zone];
        
        if (zoneRules && zoneRules.deliveryDays) {
          var deliveryMethod = zoneRules.deliveryDays[dayOfWeek];
          
          if (isInRange && deliveryMethod) {
            option.style.display = '';
            option.classList.remove('date-disabled');
            
            var methodEl = option.querySelector('.date-method');
            if (methodEl) {
              methodEl.textContent = deliveryMethod;
            }
            
            validCount++;
          } else {
            option.style.display = 'none';
            hiddenCount++;
          }
        }
      } else if (isPickupMode) {
        var dayOfWeek = optionDate.getDay();
        var pickupDays = [1, 2, 4, 5];
        var isPickupDay = pickupDays.indexOf(dayOfWeek) !== -1;
        
        if (isInRange && isPickupDay) {
          option.style.display = '';
          option.classList.remove('date-disabled');
          
          var methodEl = option.querySelector('.date-method');
          if (methodEl) {
            methodEl.textContent = 'Pickup';
          }
          
          validCount++;
        } else {
          option.style.display = 'none';
          hiddenCount++;
        }
      } else {
        if (optionDate >= startDate) {
          var wasVisible = option.style.display !== 'none' && !option.classList.contains('date-disabled');
          
          if (wasVisible) {
            option.style.display = '';
            option.classList.remove('date-disabled');
            validCount++;
          } else {
            option.style.display = 'none';
            hiddenCount++;
          }
        } else {
          option.style.display = 'none';
          hiddenCount++;
        }
      }
    }
    
    console.log('✅ ' + event.name + ' 필터링 (' + zone + ', ' + (isPickupMode ? '픽업' : '배송') + '): ' + validCount + '개 표시, ' + hiddenCount + '개 숨김');
  }
  
  function applyEventBadges(events) {
    var existingBadges = document.querySelectorAll('.event-badge');
    for (var i = 0; i < existingBadges.length; i++) {
      existingBadges[i].remove();
    }
    
    if (events.length === 0) return;
    
    var event = events[0];
    
    if (!event.badge) {
      console.log('ℹ️ ' + event.name + ': No badge');
      return;
    }
    
    var visibleDateOptions = document.querySelectorAll('.date-option:not([style*="display: none"]):not(.date-disabled)');
    var badgeCount = 0;
    
    var fulfillmentMethodInput = document.getElementById('selectedFulfillmentMethod');
    var isPickupMode = fulfillmentMethodInput && fulfillmentMethodInput.value === 'pickup';
    var badgeColor = isPickupMode ? '#2EA3EC' : event.color;
    
    for (var i = 0; i < visibleDateOptions.length; i++) {
      var option = visibleDateOptions[i];
      
      var badge = document.createElement('div');
      badge.className = 'event-badge';
      badge.style.cssText = 'font-size: 10px; color: ' + badgeColor + '; font-weight: bold; margin-top: 2px; line-height: 1;';
      badge.textContent = event.badge;
      
      option.appendChild(badge);
      badgeCount++;
      
      var originalClick = option.onclick;
      option.onclick = (function(opt, color, origClick) {
        return function(e) {
          if (origClick) origClick.call(this, e);
          
          setTimeout(function() {
            opt.style.background = color;
            opt.style.borderColor = color;
            opt.style.color = 'white';
          }, 50);
        };
      })(option, badgeColor, originalClick);
    }
    
    console.log('✅ ' + event.name + ' 배지 추가: ' + badgeCount + '개');
  }
  
  function restoreAllDates() {
    console.log('🔄 Restoring all dates to normal');
    
    var dateOptions = document.querySelectorAll('.date-option');
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      option.style.display = '';
    }
    
    var badges = document.querySelectorAll('.event-badge');
    for (var i = 0; i < badges.length; i++) {
      badges[i].remove();
    }
    
    console.log('✅ Calendar Restored to normal');
  }
  
  function selectFirstAvailableDate() {
    console.log('🎯 Selecting first available date');
    
    var dateOptions = document.querySelectorAll('.date-option');
    var firstAvailable = null;
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      
      if (option.style.display !== 'none' && 
          !option.classList.contains('date-disabled')) {
        firstAvailable = option;
        break;
      }
    }
    
    if (firstAvailable) {
      console.log('✅ First available date found:', firstAvailable.dataset.date);
      
      var allOptions = document.querySelectorAll('.date-option');
      for (var i = 0; i < allOptions.length; i++) {
        allOptions[i].classList.remove('selected', 'date-selected');
        allOptions[i].style.background = '';
        allOptions[i].style.borderColor = '';
        allOptions[i].style.color = '';
      }
      
      firstAvailable.click();
      
    } else {
      console.warn('⚠️ No available date found');
    }
  }
  
  function processEventSystem() {
    console.log('🔄 Processing Event System...');
    
    var dateGrid = document.getElementById('date-grid');
    if (!dateGrid) {
      console.warn('⚠️ date-grid not found');
      return;
    }
    
    detectEventProducts().then(function(events) {
        window._lastEventDetection = events; // ← 이 줄 추가
      console.log('📦 Detected Events:', events.length > 0 ? events.map(function(e) { return e.name; }).join(', ') : 'None');
      
      updateSubtitle(events);
      
      var calendarDays = 21;
      
      if (events.length > 0) {
        var event = events[0];
        var today = new Date();
        var eventEnd = new Date(event.dateRange.end);
        var daysUntilEnd = Math.ceil((eventEnd - today) / (1000 * 60 * 60 * 24));
        
        calendarDays = Math.max(20, daysUntilEnd + 2);
        console.log('📅 Calendar Extended: ' + calendarDays + ' days');
      }
      
      var fulfillmentMethodInput = document.getElementById('selectedFulfillmentMethod');
      var isPickupMode = fulfillmentMethodInput && fulfillmentMethodInput.value === 'pickup';
      
      var hasDeliveryFunc = typeof window.updateDeliveryCalendar === 'function';
      var hasPickupFunc = typeof window.updatePickupCalendar === 'function';
      
      if (!hasDeliveryFunc && !hasPickupFunc) {
        console.error('❌ No calendar functions');
        return;
      }
      
      var zipcode = document.getElementById('current-zipcode');
      var zip = zipcode ? zipcode.textContent : '92831';
      
      console.log('🔄 Updating calendar (' + (isPickupMode ? 'pickup' : 'delivery') + ')');
      
      if (isPickupMode && hasPickupFunc) {
        window.updatePickupCalendar(zip, calendarDays);
      } else if (hasDeliveryFunc) {
        window.updateDeliveryCalendar(zip, calendarDays);
      }
      
      setTimeout(function() {
        if (events.length > 0) {
          console.log('🎯 Applying filters');
          filterEventDates(events);
          applyEventBadges(events);
          selectFirstAvailableDate();
        } else {
          console.log('🔄 Normal mode');
          restoreAllDates();
          selectFirstAvailableDate();
        }
      }, 100);
      
    }).catch(function(error) {
      console.error('❌ Error:', error);
    });
  }
  
  function setupEventListeners() {
    console.log('🎧 Setting up event listeners');
    
    var debounceTimer = null;
    var isProcessing = false;
    var lastProcessTime = 0;
    var MIN_PROCESS_INTERVAL = 3000;
    
    function debouncedProcessEventSystem(delay) {
      delay = delay || 2000;
      
      var now = Date.now();
      if (now - lastProcessTime < MIN_PROCESS_INTERVAL) {
        return;
      }
      
      if (isProcessing) {
        return;
      }
      
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      
      debounceTimer = setTimeout(function() {
        isProcessing = true;
        lastProcessTime = Date.now();
        console.log('🔄 Processing...');
        
        processEventSystem();
        
        setTimeout(function() {
          isProcessing = false;
        }, 2000);
      }, delay);
    }
    
    var eventTypes = ['click', 'touchend'];
    for (var i = 0; i < eventTypes.length; i++) {
      document.addEventListener(eventTypes[i], function(e) {
        var target = e.target;
        
        var quantityButton = target.closest('.quantity__button') || 
                            target.closest('button[name="plus"]') || 
                            target.closest('button[name="minus"]');
        
        var removeButton = target.closest('cart-remove-button') || 
                          target.closest('.cart-item__remove');
        
        if (quantityButton || removeButton) {
          console.log('🛒 Cart button clicked');
          debouncedProcessEventSystem(2000);
        }
      }, { passive: true });
    }
    
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('quantity__input') || 
          e.target.name === 'updates[]') {
        console.log('🛒 Quantity changed');
        debouncedProcessEventSystem(1500);
      }
    });
    
    var cartEventNames = ['cart:updated'];
    for (var i = 0; i < cartEventNames.length; i++) {
      document.addEventListener(cartEventNames[i], function(e) {
        console.log('🛒 Shopify event:', e.type);
        debouncedProcessEventSystem(1500);
      })
    }
    
    window.addEventListener('chefBanchanZipCodeChanged', function() {
      console.log('📍 ZIP changed');
      debouncedProcessEventSystem(1000);
    });
    
    window.addEventListener('chefBanchanFulfillmentChanged', function(e) {
      console.log('🔄 배송/픽업 모드 변경:', e.detail.method);
      
      // 이벤트 제품 있는지 빠르게 체크
      detectEventProducts().then(function(events) {
        if (events.length > 0) {
          // 이벤트 있으면 전체 프로세스
          processEventSystem();
        } else {
          // 이벤트 없으면 subtitle만 업데이트 (캘린더 재생성 안 함)
          updateSubtitle(events);
        }
      });
    });
    
    console.log('✅ Event listeners ready');
  }
  
  window.eventSystemTest = {
    check: detectEventProducts,
    process: processEventSystem,
    restore: restoreAllDates,
    getActive: getActiveEvents,
    filter: filterEventDates,
    updateSubtitle: updateSubtitle,
    selectFirst: selectFirstAvailableDate
  };
  
  function initialize() {
    console.log('🚀 Event System Initialize');
    var activeEvents = getActiveEvents();
    var names = activeEvents.map(function(e) { return e.name; }).join(', ');
    console.log('📋 Active Events: ' + names);
    
    function waitForEverything(attempts) {
      attempts = attempts || 0;
      
      var hasZipManager = window.ChefBanchan && window.ChefBanchan.ZipCodeManager;
      var dateGrid = document.getElementById('date-grid');
      var hasCalendar = dateGrid && dateGrid.children.length > 0;
      var hasUpdateFunction = typeof window.updateDeliveryCalendar === 'function';
      
      if (attempts === 0 || attempts % 10 === 0) {
        console.log('🔍 System Check (Attempt ' + attempts + '/100):');
        console.log('   ZIP Manager:', hasZipManager ? '✓' : '✗');
        console.log('   Calendar:', hasCalendar ? '✓' : '✗');
        console.log('   Update Function:', hasUpdateFunction ? '✓' : '✗');
      }
      
      if (hasZipManager && hasCalendar && hasUpdateFunction) {
        console.log('✅ All systems ready - Starting Event System');
        processEventSystem();
        setupEventListeners();
      } else if (attempts < 100) {
        setTimeout(function() {
          waitForEverything(attempts + 1);
        }, 200);
      } else {
        console.error('❌ Event System timeout');
      }
    }
    
    waitForEverything(0);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 500);
  }
  
})();